import React, { useEffect, useState } from 'react'
import "./style.scss"
import { useTranslation } from 'react-i18next'
import { changeLanguage } from '../../../../components/helper'
import { useParams } from 'react-router-dom'
import UserInfo from './widgets/UserInfo'
import RegisterSteps from './widgets/RegisterSteps'
import DomainForm from './widgets/DomainForm'
import FinishStep from './widgets/FinishStep'
import InvoiceStep from './widgets/InvoiceStep'
import PayBack from './widgets/PayBack'

const Register = () => {
    const [widthScreen, setWidthScreen] = useState(window.innerWidth)
    const params = useParams()

    const { t, i18n } = useTranslation()
    let direction = i18n.dir()


    useEffect(() => {
        document.title = t("TITLES.REGISTER_PAGE")
    }, [])


    return (
        <div className={`d-flex flex-row justify-content-between auth-form register-page`}>
            <div className='section-right' >

                <div className='d-flex flex-row justify-content-center' >

                    <div className='login-section '>
                        <div className='d-flex flex-row justify-content-between mb-3' >
                            <a href='https://dartamas.com/' className='text-decoration-none'>
                                <button className='btn btn-default main-page-btn' type="button"
                                >{t('MAIN.PAGE_SITE')}</button>

                            </a>
                            <div className='d-flex flex-column justify-content-start' >
                                <div className='d-flex flex-row justify-content-end'>
                                    <button className='btn btn-default main-page-btn' style={{ width: '40px' }} onClick={() => changeLanguage(i18n, direction)} >{direction === 'ltr' ? 'فا' : 'En'}</button>
                                </div>
                            </div>
                        </div>
                        <RegisterSteps type={((params.packageId && params.durationId) || params.invoiceId) ? 'not-package-free' : 'package-free'} />

                        {params.step === "userInfo" ? <UserInfo /> :
                            params.step === "websiteAddress" ? <DomainForm /> :
                                params.step === "package" ? <InvoiceStep /> :
                                    params.step === "payBack" ? <PayBack /> :
                                        params.step === "finish" ? <FinishStep /> : ""}


                        <div className='Copywriter d-flex flex-row justify-content-center' style={{ direction: 'ltr' }}>
                            <p>{t('COPY_WRITE')}</p>
                        </div>
                    </div>
                </div>


            </div>
            {widthScreen > 1024 ? <div
                className={`image-container`}>
                <div className={`${i18n.language === 'fa' ? 'fa' : 'en'}`}></div>
            </div> : ''}

        </div>
    )
}

export default Register